import { styled } from '@mui/material/styles';
import QRCode from 'react-qr-code';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';

export const StyledOverlayHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => theme.typography.text_19_bold_lh_22};
    ${({ theme }: { theme: Theme }) => `
        && {
            margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        }

        text-align: center;
	`}
`;

export const StyledParagraph = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        line-height: ${theme.tggSpacing(rem(2), 5)};
        text-align: center;
	`}
`;

export const StyledQRBorder = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(17), 42.5)};
        height: ${theme.tggSpacing(rem(17), 42.5)};
        margin: auto;
        border: ${theme.tggSpacing(rem(0.7), 3)} solid #000;
        border-radius: ${theme.tggSpacing(rem(1), 2.5)};
	`}
`;

export const StyledQRCode = styled(QRCode)`
    ${({ theme }: { theme: Theme }) => `
        display: block;
        width: 80%;
        height: 80%;
        margin: ${theme.tggSpacing([rem(1.6), 'auto', 0, 'auto'], [4, 'auto', 0, 'auto'])};
	`}
`;

export const StyledLink = styled('a')`
    font-weight: bold;
`;
